// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Enumerations/ProjectSortBy.proto (package time_tracking.enumerations, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import { file_Options_EnumValueOptions } from "../Options/EnumValueOptions_pb";

/**
 * Describes the file Enumerations/ProjectSortBy.proto.
 */
export const file_Enumerations_ProjectSortBy: GenFile = /*@__PURE__*/
  fileDesc("CiBFbnVtZXJhdGlvbnMvUHJvamVjdFNvcnRCeS5wcm90bxIadGltZV90cmFja2luZy5lbnVtZXJhdGlvbnMq1wIKDVByb2plY3RTb3J0QnkSHwobUFJPSkVDVF9TT1JUX0JZX1VOU1BFQ0lGSUVEEAASJQoZUFJPSkVDVF9TT1JUX0JZX1RFTkFOVF9JRBADGgbKx80PAQMSIAoUUFJPSkVDVF9TT1JUX0JZX05BTUUQBBoGysfNDwEEEiQKGFBST0pFQ1RfU09SVF9CWV9TVEFSVF9BVBAGGgbKx80PAQYSIgoWUFJPSkVDVF9TT1JUX0JZX0VORF9BVBAHGgbKx80PAQcSJwoaUFJPSkVDVF9TT1JUX0JZX0NSRUFURURfQVQQZBoHysfNDwJkARIoChtQUk9KRUNUX1NPUlRfQllfTU9ESUZJRURfQVQQZRoHysfNDwJkAhInChpQUk9KRUNUX1NPUlRfQllfREVMRVRFRF9BVBBmGgfKx80PAmQDIgQIARABIgQIAhACIgQIBRAFIgQICBBjQiiqAiVNb2dpLlRpbWVUcmFja2luZy5Db21tb24uRW51bWVyYXRpb25zYgZwcm90bzM", [file_Options_EnumValueOptions]);

/**
 * Determines by which columns to sort projects by.
 *
 * @generated from enum time_tracking.enumerations.ProjectSortBy
 */
export enum ProjectSortBy {
  /**
   * Do not apply any specific sorting to the query.
   *
   * @generated from enum value: PROJECT_SORT_BY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Sort the projects by their tenant id.
   *
   * @generated from enum value: PROJECT_SORT_BY_TENANT_ID = 3;
   */
  TENANT_ID = 3,

  /**
   * Sort the projects by their name.
   *
   * @generated from enum value: PROJECT_SORT_BY_NAME = 4;
   */
  NAME = 4,

  /**
   * Sort the project by their start-at date
   *
   * @generated from enum value: PROJECT_SORT_BY_START_AT = 6;
   */
  START_AT = 6,

  /**
   * Sort the project by their end-at date
   *
   * @generated from enum value: PROJECT_SORT_BY_END_AT = 7;
   */
  END_AT = 7,

  /**
   * Sort the projects by their creation time stamp.
   *
   * @generated from enum value: PROJECT_SORT_BY_CREATED_AT = 100;
   */
  CREATED_AT = 100,

  /**
   * Sort the projects by their modification time stamp.
   *
   * @generated from enum value: PROJECT_SORT_BY_MODIFIED_AT = 101;
   */
  MODIFIED_AT = 101,

  /**
   * Sort the projects by their deletion time stamp.
   *
   * @generated from enum value: PROJECT_SORT_BY_DELETED_AT = 102;
   */
  DELETED_AT = 102,
}

/**
 * Describes the enum time_tracking.enumerations.ProjectSortBy.
 */
export const ProjectSortBySchema: GenEnum<ProjectSortBy> = /*@__PURE__*/
  enumDesc(file_Enumerations_ProjectSortBy, 0);

